/**
 * Re-enabling the date-reminders automation leaves reminders stale for any
 * date property that changed while it was off. The opt-in endpoint doubles as
 * a backfill trigger, so every surface that can flip
 * `reminder_from_date_properties` back on fires it — settings list and record
 * slideout alike.
 */

import { apiPost } from '@/lib/http/client';

export const REMINDER_AUTOMATION_SCRIPT_NAME = 'reminder_from_date_properties';

/**
 * Fire-and-forget: backfill failure is non-critical — reminders catch up on
 * the next property change — so the returned promise never rejects.
 */
export async function triggerReminderBackfill(orgId: number): Promise<void> {
  await apiPost(
    `/api/orgs/${orgId}/crm/automations/${REMINDER_AUTOMATION_SCRIPT_NAME}/`,
    {}
  ).catch(() => {
    // Swallowed deliberately (see above).
  });
}
